<template>
	<tabbed-page-layout class="planning" title="Planlægning" :pages="pages" />
</template>

<script>
    export default {
		props: ['pages']
    }
</script>

<style lang="scss">

</style>